$ = require 'jquery'
ArchiveView = require 'app/scripts/views/archive/archive-view'
Auth = require 'app/scripts/db/auth'
BoardMenuAboutThisBoardView = require 'app/scripts/views/board-menu/board-menu-about-this-board-view'
BoardLabelsView = require 'app/scripts/views/board-menu/board-labels-view'
BoardMenuActivityView = require 'app/scripts/views/board-menu/board-menu-activity-view'
BoardSidebarDefaultView = require 'app/scripts/views/board-menu/board-sidebar-default-view'
BoardSettingsView = require 'app/scripts/views/board-menu/board-settings-view'
BoardMenuMoreView = require 'app/scripts/views/board-menu/board-menu-more-view'
BoardCollectionsView = require 'app/scripts/views/board-menu/board-collections-view'
CardFilterView = require 'app/scripts/views/board-menu/card-filter-view'
ChangeBoardBackgroundView = require 'app/scripts/views/board-menu/change-board-background-view'
ChangeBoardBackgroundSelectView = require 'app/scripts/views/board-menu/change-board-background-select-view'
getExperiment = require 'app/scripts/lib/experiments/simple-test'
{ Key, registerShortcut, Scope, unregisterShortcut, } = require '@trello/keybindings'
PopOver = require 'app/scripts/views/lib/pop-over'
StickerPickerView = require 'app/scripts/views/board-menu/sticker-picker-view'
{ Storage } = require '@trello/storage'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
{ featureFlagClient } = require '@trello/feature-flag-client'
templates = require 'app/scripts/views/internal/templates'
{ track, trackUe } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'

module.exports = class BoardSidebarView extends View

  initialize: ({ @boardView }) ->
    registerShortcut(@onShortcut, { scope: Scope.Sidebar, key: Key.f })

    @templateFlagEnabled = @boardView.templateFlagEnabled
    featureFlagClient.on 'publicproduct.templates_v1', (newVal) =>
      @handleTemplateMode(newVal)

    @listenTo @model,
      'change:prefs.isTemplate': ->
        @handleTemplateMode()

    @aboutView = @subview(BoardMenuAboutThisBoardView, @model, sidebarView: @)
    @defaultView = @subview(BoardSidebarDefaultView, @model, sidebarView: @)

    # Set up default view
    if @templateFlagEnabled && @model.isTemplate() && !@model.owned() # visiting a template
      @viewStack = [{ name: 'about', view: @aboutView }]
    else
      @viewStack = [{ name: 'default', view: @defaultView }]
      isTemplate = @templateFlagEnabled && @model.isTemplate()
      hasDescOrIsOwner = !!@model.get('desc') || @model.ownedByMember(Auth.me())
      if @model.isPublic() && hasDescOrIsOwner || isTemplate
        @pushView('about', {}, { easeIn: false, showSidebar: @model.viewState.get('showSidebar') })

    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

    return

  remove: ->
    unregisterShortcut(@onShortcut)
    super

  events:
    'click .js-hide-sidebar': 'hideSidebar'
    'click .js-pop-widget-view': 'popView'

  onShortcut: =>
    @pushView 'filter'
    track 'Keyboard Shortcuts', 'F - Search and Filter Cards'
    if @sendGASEvent
      Analytics.sendUIEvent
        action: 'pressed',
        actionSubject: 'keyboardShortcut',
        source: 'boardScreen'
        attributes:
          keyValue: 'F'

  className: 'board-menu-container'

  render: ->

    @$el.html(
      templates.fill(
        'board_sidebar'
      )
    )

    # Defer until LD flag value is updated
    @defer =>
      @renderView()

    @

  # Because of these classes aren't yet defined, we need to make this a
  # function. When we get proper requiring, this can become a normal object.
  sidebarSubviews: ->
    default: BoardSidebarDefaultView
    filter: CardFilterView
    about: BoardMenuAboutThisBoardView
    archive: ArchiveView
    stickers: StickerPickerView
    labels: BoardLabelsView
    background: ChangeBoardBackgroundView
    backgroundColors: ChangeBoardBackgroundSelectView
    backgroundPhotos: ChangeBoardBackgroundSelectView
    activity: BoardMenuActivityView
    more: BoardMenuMoreView
    settings: BoardSettingsView
    collections: BoardCollectionsView

  hackySidebarLifetimeEvents:
    filter:
      didBecomeVisible: (view) ->
        input = view.$('.js-autofocus')[0]
        Util.setCaretAtEnd input
    more:
      didBecomeVisible: (view) ->
        view.selectUrl()
    archive:
      didBecomeVisible: (view) ->
        input = view.$('.js-autofocus')[0]
        Util.setCaretAtEnd input

  viewNamed: (viewName, options) ->
    for { name, view } in @viewStack
      if viewName == name
        return view

    viewClass = _.result(@, 'sidebarSubviews')[viewName]
    if !viewClass?
      throw new Error "Unknown sidebar view #{viewName}"
    model = if viewName == 'filter' then @model.filter else @model
    new viewClass(_.extend({ model, @modelCache, sidebarView: @, viewState: options?.viewState }, options))

  topSidebarView: ->
    _.last(@viewStack).view

  topSidebarViewOptions: ->
    _.last(@viewStack).options

  topSidebarViewName: ->
    _.last(@viewStack).name

  getScreenFromViewName: (viewName = @topSidebarViewName()) ->
    screenName = viewName[0].toUpperCase() + viewName[1..-1]
    return "boardMenuDrawer#{screenName}Screen"

  sendDrawerScreenEvent: (sourceScreen, method) ->
    if !@sendGASEvent
      return

    Analytics.sendScreenEvent
      name: @getScreenFromViewName()
      containers:
        board:
          id: @model.id
        organization:
          id: @model.getOrganization()?.id || ''
      attributes:
        previousDrawerScreen: @getScreenFromViewName(sourceScreen)
        drawerNavigationMethod: method

  renderView: (options = {}) ->
    { direction, callOnce, easeIn } = options
    $title = @$('.js-board-menu-title')
    $titleIcon = @$('.js-board-menu-title-icon').empty()
    $titleText = @$('.js-board-menu-title-text').empty()
    $contentWrapper = @$('.js-board-menu-content-wrapper').empty().scrollTop(0)

    view = @topSidebarView()

    @$('.board-menu-header').toggleClass('no-transition', !easeIn)
    $contentWrapper.toggleClass('no-padding', view.noPadding == true)

    if view.headerDisplayTypeClass?
      @$('.js-board-menu-title').addClass(view.headerDisplayTypeClass)
    else if @viewStack.length == 1
      @$('.js-board-menu-title').addClass('is-board-menu-default-view')
    else
      @$('.js-board-menu-title').removeClass('is-board-menu-default-view')

    $content = view.renderIfNecessary().$el

    if direction? then $content.addClass(direction)

    title = view.getViewTitle()
    if title
      $title.addClass('is-in-frame')
      $titleText.append title
    else
      $title.removeClass('is-in-frame')

    $contentWrapper.append($content)

    # this needs to be instantiated after the $contentWrapper has been cleared
    # of `.board-menu-content-frame`s and after inserting the current frame.
    # Otherwise, the transitionend triggers earlier on an old frame and we
    # don't get our didBecomeVisible.
    if callOnce?
      $('.board-menu-content-frame').one 'transitionend webkitTransitionEnd', (e) =>
        callOnce(view)

    @defer =>
      # without the defer, the browser removes the class too quickly and
      # doesn't animate. i think they are batched somehow.
      if direction? then $content.removeClass(direction)

    # the view can drop events, like when loading a bunch of other sidebar
    # views then using the 'f' shortcut, so reattach them here just in case.
    view.delegateEvents()
    @

  pushView: (name, viewOptions = {}, options = {}) ->
    { animate, showSidebar, easeIn } = options
    animate ?= true
    showSidebar ?= true
    easeIn ?= true

    view = @viewNamed name, viewOptions

    didBecomeVisible = @hackySidebarLifetimeEvents?[name]?.didBecomeVisible ? ->

    isCurrentTopView = view == @topSidebarView()
    isSidebarVisible = @model.viewState.get 'showSidebar'

    if !isSidebarVisible
      $('.board-menu').one 'transitionend webkitTransitionEnd', (e) =>
        didBecomeVisible view
    else if !isCurrentTopView
      callOnce = didBecomeVisible
    else
      didBecomeVisible view

    if showSidebar && !isSidebarVisible
      @model.viewState.setShowSidebar true

    if isCurrentTopView
      return

    previousViewName = @topSidebarViewName()
    @viewStack.push { name, view, options: viewOptions }
    direction =
      if animate
        'is-right-of-frame'
    @renderView({ direction, callOnce, easeIn })

    trackUe('board sidebar', 'opens', "#{@topSidebarViewName()} view", "from #{previousViewName} view",
      '', '', { boardId: @model.id, teamId: @model.getOrganization()?.id } )
    @sendDrawerScreenEvent(previousViewName, 'push')

    PopOver.hide()
    return

  popView: ->
    if @viewStack.length == 1
      # This is fine -- the board view will try to call this if you hit
      # escape. There's no reason to let the board view know anything
      # about our view stack, as it's internal, so we just silently ignore
      # such a request.
      return

    resetView = @topSidebarViewOptions()?.resetTo
    if resetView
      return @resetTo(resetView)

    previousViewName = @topSidebarViewName()
    @topSidebarView().remove()
    @viewStack.pop()
    @renderView({ animate: 'is-left-of-frame', easeIn: true })

    trackUe('board sidebar', 'opens', "#{@topSidebarViewName()} view", "from #{previousViewName} view",
      '', "by clicking on back button", { boardId: @model.id, teamId: @model.getOrganization()?.id } )
    @sendDrawerScreenEvent(previousViewName, 'back')

    PopOver.hide()
    return

  resetTo: (view, options = {}) ->
    { animate, showSidebar } = options
    animate ?= true

    previousViewName = @topSidebarViewName()
    while @viewStack.length != 1
      @viewStack.pop()

    if view
      @pushView view, {}, options

    @renderView({ animate: if animate then 'is-left-of-frame' })

    trackUe('board sidebar', 'opens', "#{@topSidebarViewName()} view", "from #{previousViewName} view",
      '', 'via reset', { boardId: @model.id, teamId: @model.getOrganization()?.id } )
    @sendDrawerScreenEvent(previousViewName, 'reset')

    PopOver.hide()
    return

  hideSidebar: ->
    @model.viewState.setShowSidebar(false)
    trackUe('board sidebar', 'closes', 'sidebar', "on #{@topSidebarViewName()} view",
      '', '', { boardId: @model.id, teamId: @model.getOrganization()?.id } )
    if @sendGASEvent
      Analytics.sendUIEvent
        action: 'clicked'
        actionSubject: 'button'
        actionSubjectId: 'boardMenuDrawerCloseButton'
        source: @getScreenFromViewName()
        containers:
          board:
            id: @model.id
          organization:
            id: @model.getOrganization()?.id || ''

    return

  getBoardView: ->
    @boardView

  handleTemplateMode: (newVal) ->
    if newVal?
      @templateFlagEnabled = newVal

    templateModeEnabled = @templateFlagEnabled && @model.isTemplate()
    visitingTemplate = templateModeEnabled && !@model.owned()
    if visitingTemplate
      # ATB becomes default view for visitors on templates
      @viewStack = [{ name: 'about', view: @aboutView }]
      @renderView()
    else if templateModeEnabled || @topSidebarViewName() == 'about'
      # In template mode: Bring them to ATB
      # Not in template mode: Reset ATB to update view title
      @viewStack = [{ name: 'default', view: @defaultView }]
      @pushView('about', {}, { easeIn: false, showSidebar: @model.viewState.get('showSidebar') })

  sendClickedDrawerNavItemEvent: (menuName, navItem, attributes = {}) ->
    if !@sendGASEvent
      return

    # Ensure that values are camel cased appropriately
    menuName = menuName[0].toUpperCase() + menuName[1..-1].toLowerCase()
    navItem = navItem[0].toLowerCase() + navItem[1..-1]

    eventProperties =
      action: 'clicked'
      actionSubject: 'drawerNavigationItem'
      actionSubjectId: navItem + 'DrawerNavigationItem'
      source: 'boardMenuDrawer' + menuName + 'Screen'
      containers:
        board:
          id: @model.id
        organization:
          id: @model.getOrganization()?.id || ''

    if Object.keys(attributes).length
      eventProperties.attributes = attributes

    Analytics.sendUIEvent(eventProperties)
